import { Box, Thumbnail, Text } from '@nimbus-ds/components';
import { InteractiveList } from '@nimbus-ds/patterns';

const PRODUCT_IMAGE_WIDTH = '56px';
const SKELETON_ITEMS_COUNT = 10;

export function SelectProductModalSkeleton(): JSX.Element {
  return (
    <InteractiveList>
      {Array(SKELETON_ITEMS_COUNT)
        .fill(null)
        .map((_, i) => (
          <InteractiveList.CheckboxItemSkeleton
            key={i}
            title=""
            showTitle={false}
          >
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="flex-start"
              width="100%"
              gap="3"
            >
              <Box width="56px" height="56px" flex="0 0 56px" overflow="hidden">
                <Thumbnail.Skeleton width={PRODUCT_IMAGE_WIDTH} />
              </Box>
              <Box
                flex="1"
                display="flex"
                flexDirection="column"
                gap="1"
                minWidth="0"
              >
                <Text.Skeleton width="large" />
                <Text.Skeleton width="medium" />
              </Box>
            </Box>
          </InteractiveList.CheckboxItemSkeleton>
        ))}
    </InteractiveList>
  );
}
